export const historyMarkup = String.raw`<!-- ====== HISTORY VIEW ====== -->
    <div class="view" id="view-history">
      <header class="contextual-page-header">
        <div class="topic-back-row">
          <button class="btn btn-default btn-sm topic-back-pill" data-proto-click="returnFromHistory()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg>
            Back
          </button>
        </div>
        <h1 class="heading-1">History</h1>
        <p>Every topic you've started, most recent first. Pick up where you left off.</p>
      </header>
      <div class="history-list" id="historyList" data-history-root>
        <div class="home-recent-skeleton" aria-hidden="true"></div>
        <div class="home-recent-skeleton" aria-hidden="true"></div>
        <div class="home-recent-skeleton" aria-hidden="true"></div>
      </div>
    </div>

    `;
